export const Increments = {
  Day: 'Day',
  Week: 'Week',
  Month: 'Month',
};

export default { Increments };
